import Signal, { s_invoke } from "badmfck-signal";
import { useEffect, useState } from "react";
import "./fonts.css";
import "./i18n";
import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import { Accounts } from "./services/Accounts.ts";
import { AcquirerService } from "./services/AcquirerService.ts";
import { AuthService } from "./services/AuthService.ts";
import { BalancerService } from "./services/BalancerService.ts";
import { BanksService } from "./services/BanksService.ts";
import { CardService } from "./services/CardService.ts";
import { ClientService } from "./services/ClientService.ts";
import { Common } from "./services/Common.ts";
import { FileService } from "./services/FileService.ts";
import { FraudService } from "./services/FraudService.ts";
import HTTP from "./services/HTTP.ts";
import { MerchantAuthService } from "./services/MerchantAuthService.ts";
import { MerchantService } from "./services/MerchantService.ts";
import { Projects } from "./services/Projects.ts";
import { RateService } from "./services/RateService.ts";
import { TerminalService } from "./services/TerminalService.ts";
import { Transactions } from "./services/Transactions.ts";
import { UsersService } from "./services/UsersService.ts";
Signal.setupReact(useState, useEffect);

window.addEventListener("resize", () => {
	s_invoke({ width: window.innerWidth, height: window.innerHeight }, "resize");
});

new Projects();
new HTTP();
//new Users();
new Accounts();
new Transactions();
new CardService();
new Common();
new AuthService();
new FraudService();
new ClientService();
new AcquirerService();
new RateService();
new MerchantAuthService();
new TerminalService();
new BalancerService();
new BanksService();
new MerchantService();
new FileService();
new UsersService();

setTimeout(() => {
	//GD.S_CLIENT_EDITOR.invoke();
}, 1000);

createRoot(document.getElementById("root")!).render(<App />);
